<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Deelnemingen
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse show" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>In de specificatie 'Deelnemingen' geef je een overzicht van de deelnemingen. Je vermeldt hier ook de
                    deelnemingen die in dit boekjaar zijn verworven, vervreemd of ontbonden.</p>
                <p>Deelnemingen zijn onder te verdelen in:</p>
                <ul>
                    <li>deelnemingen.</li>
                    <li>deelnemingen door gelijkstelling.</li>
                    <li>deelnemingen door de meetrekregeling.</li>
                </ul>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Deelnemingen
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Winsten en verliezen uit een deelneming maken in het algemeen geen deel uit van de belastbare winst
                    (deelnemingsvrijstelling). Met de deelnemingsvrijstelling voorkom je dat winst die al eerder is
                    belast bij een dochtermaatschappij, nog een keer wordt belast bij de moedermaatschappij.</p>
                <p>Bij winsten gaat het bijvoorbeeld om ontvangen dividend en om winst bij verkoop van een deelneming.
                    Bij verliezen gaat het bijvoorbeeld om verlies bij verkoop van een deelneming. De winsten zijn in
                    dit geval niet belast. De verliezen zijn niet aftrekbaar. Aan- en verkoopkosten van een deelneming
                    zijn niet aftrekbaar.</p>
                <p>Er is sprake van een deelneming in de volgende gevallen:</p>
                <ul>
                    <li>De vennootschap is voor ten minste 5% van het nominaal gestorte kapitaal aandeelhouder van een
                        vennootschap
                        waarvan het kapitaal geheel of gedeeltelijk in aandelen is verdeeld (bijvoorbeeld een naamloze
                        of besloten vennootschap).
                    </li>
                    <li>De vennootschap bezit ten minste 5% van het aantal bewijzen van deelgerechtigdheid dat in omloop
                        is in een
                        fonds voor gemene rekening.
                    </li>
                    <li>De vennootschap is lid van een coöperatie of van een vereniging op coöperatieve grondslag.</li>
                    <li>De vennootschap neemt als commanditair vennoot voor ten minste 5% deel in een open commanditaire
                        vennootschap.
                    </li>
                    <li>De vennootschap bezit aandelen die een stemrecht van ten minste 5% vertegenwoordigen in een
                        vennootschap die
                        in een EU-lidstaat is gevestigd. Voorwaarde hierbij is dat met deze lidstaat een verdrag ter
                        voorkoming van dubbele belasting is gesloten dat voorziet in een verlaging van belastingheffing
                        op dividenden op grond van het aantal stemrechten.
                    </li>
                </ul>
                <p>Een aandelenbezit van minder dan 5% kan geen deelneming vormen. Er is 1 uitzondering: Als een
                    deelneming van ten minste 5% na een bezit van meer dan 1 jaar daalt onder het 5%-niveau, dan is de
                    deelnemingsvrijstelling nog 3 jaar van toepassing.</p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Deelneming door de meesleepregeling (gelijkstelling)
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Als de vennootschap een deelneming heeft in een vennootschap en in die vennootschap ook deelneemt
                    door het bezitten van winstbewijzen, worden ook de winstbewijzen als deelneming beschouwd. Dit geldt
                    niet als de vennootschap een deelneming uitsluitend bezit op grond van de meetrekregeling.</p>
                <p>Ook als deelneming wordt beschouwd een hybride lening aan een vennootschap waarin de vennootschap een
                    deelneming bezit. Ook dit geldt niet als de vennootschap een deelneming uitsluitend bezit op grond
                    van de meetrekregeling.</p>

            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Deelneming door de meetrekregeling
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Er is ook een deelneming in de volgende gevallen:</p>
                <ul>
                    <li>de vennootschap is aandeelhouder in een met u verbonden lichaam in de zin van artikel 10a, lid 4
                        Vpb.
                    </li>
                    <li>de vennootschap is aandeelhouder in een vennootschap waarin een met de vennootschap verbonden
                        lichaam een deelneming
                        heeft.
                    </li>
                    <li>de vennootschap heeft een hybride lening verstrekt aan een vennootschap, en een met de
                        vennootschap verbonden lichaam heeft
                        een deelneming in die vennootschap.
                    </li>
                    <li>de vennootschap heeft een hybride lening verstrekt aan een met de vennootschap verbonden
                        vennootschap.
                    </li>
                    <li>de vennootschap heeft een winstbewijs van een vennootschap waarin een met de vennootschap
                        verbonden lichaam een deelneming
                        heeft.
                    </li>
                    <li>de vennootschap heeft een winstbewijs van een met de vennootschap verbonden lichaam.</li>
                </ul>

            </div>
        </div>
    </div>
</div>
